import type { ReactNode } from 'react';
import markUrl from '@/public/logo/mark-color.svg';
import { LegalFooter } from '../../Authentication/AuthLayout';

type OnboardingFrameProps = { children: ReactNode };

/**
 * The page a new account sees until it is set up: the white auth page's gutter, the bare
 * mark and a way out, one centred column, and the legal footer. Same family as the sign-in
 * and verify screens it follows.
 */
export const OnboardingFrame = ({ children }: OnboardingFrameProps) => (
  <div className="bg-panel flex min-h-screen flex-col gap-2.5 p-2.5">
    <main className="flex min-w-0 flex-1 flex-col px-4 pt-[26px] md:px-8">
      <div className="mx-auto flex w-full max-w-[920px] flex-col gap-6 pt-6 pb-2">
        <div className="mb-[18px] flex items-center justify-between gap-4">
          <img className="h-8 w-auto" src={markUrl} alt="Pertento" />
          <a
            href="/auth/signout"
            className="text-dim hover:text-foreground text-meta underline-offset-4 hover:underline"
          >
            Sign out
          </a>
        </div>
        {children}
      </div>
    </main>
    <LegalFooter className="flex px-3 pt-2 pb-1" />
  </div>
);
